import ReactSVG from 'react-svg';
import { useEffect } from 'react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

import {alpha} from '../../utils/color';
import useTheme from '../hooks/useTheme';
import { isIphoneX } from '../../utils/util';
import RootStore from '../../store/RootStore';
import JigsawBottom from '../ComponentNavigator/JigsawBottom';
import { maxNumberByType, minNumberByType } from '../ComponentNavigator/jigsaw-limits';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

import './AllForBottom.scss';

export interface IAllForBottom {
  rootStore?:RootStore;
  currentTab:string;
  onTabClick:(tab:INavigatorTab)=>void;
  tabs:INavigatorTab[];
  component?:any;
}

export interface INavigatorTab {
  type:string;
  icon:string;
  active:string;
  text:string;
  useBack?:boolean;
}

const Index = (props:IAllForBottom)=>{
  const {currentTab, onTabClick, tabs, component} = props;
  const { uiStore } = props.rootStore!;
  const activeGallery = activeGalleryInstance.get();
  const jigsaw = activeGallery ? activeGallery.jigsaw : { bottomShow: false, jigsawList: [] as any[], type: '', from: '' };
  const setJigsaw = activeGallery ? activeGallery.setJigsaw : (() => {});
  const { bottomShow, jigsawList, type } = jigsaw;

  const theme = useTheme();

  const getScreenBottom = ()=>{
    return isIphoneX() ? 22 : 0;
  };

  const onCancel = () => {
    if (jigsaw && jigsaw.from === 'bigpic') {
      let changeEvent = new Event('CHANGE_BODY_SCROLL') as any;
      changeEvent.data = false;
      window.dispatchEvent(changeEvent);
    }
    setJigsaw({ bottomShow: false, jigsawList: [] });
  };

  const onConfirm = () => {
    const length = jigsawList.length;
    if (length < minNumberByType(type)) {
      const minKey = type === 'download' ? 'min-download' : 'min-jigsaw';
      uiStore.showAlert({
        content: intl.get(minKey, { num: minNumberByType(type) }),
      });
      return;
    }

    if (length > maxNumberByType(type)) {
      const maxKey =
        type === 'download' ? 'MAX_DOWNLOAD_NUM' : 'MAX_JIGSAW_NUM';
      uiStore.showAlert({
        content: intl.get(maxKey, { num: maxNumberByType(type) }),
      });
      return;
    }
  };

  useEffect(() => {
    const bottom = document.querySelector('.all-for-bottom');
    if (bottom) {
      const height = bottom.clientHeight;
      document.documentElement.style.setProperty('--bottom-height', `${height}px`);
    }
  }, [tabs, bottomShow, jigsawList.length]);

  if (bottomShow) {
    return (
      <JigsawBottom
        onCancel={onCancel}
        onConfirm={onConfirm}
        type={type}
        list={jigsawList}
      />
    );
  }

  return <div className="all-for-bottom">
    {tabs && tabs.length > 1 ? <div className="bottom-tab" style={{ 
      paddingBottom:getScreenBottom(),
      backgroundColor: component && component.container && component.container.useThemeColor === false ? component.container.componentBg : alpha(theme.componentColor, 1),
    }}>
      {tabs.map((it:INavigatorTab, index:number)=>{
        let isActive = currentTab === it.type;
        return <div className="bottom-tab-one" key={index} onClick={()=>{
          onTabClick(it);
        }}>
          <ReactSVG
            src={isActive ? it.active : it.icon}
            className="tab-icon"
            style={{ color: isActive ? theme.mainColor : theme.h2Color, fill: isActive ? theme.mainColor : theme.h2Color }}
          />
          <div className="tab-name" style={{color: isActive ? theme.mainColor : theme.h2Color}}>{it.text}</div>
        </div>;
      })}
    </div> : null}
  </div>;
};

export default inject('rootStore')(observer(Index));
